import React from 'react';
import propTypes from 'prop-types';
import defaultPropValues from '../helper/defaultPropValues';
import validate from '../utils/label-validator';
import './Video.scss';

const Video = (props) => {
	const data = { ...defaultPropValues.videoProps.data, ...props.data };
	const {
		videoSrc,
		videoThumbNail,
		videoWidth,
		videoHeight,
		showControls,
		autoPlay,
		loop,
		muted,
		VideoTextHeightMQ
	} = data;
	const additionalVideoProps = {};
	const additionalClasses = [];
	if (showControls) additionalVideoProps.controls = 'controls';
	if (autoPlay) additionalVideoProps.autoPlay = 'autoplay';
	if (loop) additionalVideoProps.loop = 'loop';
	if (muted) additionalVideoProps.muted = 'muted';
	if (validate(videoThumbNail))
		additionalVideoProps.poster = `${videoThumbNail}`;
	if (VideoTextHeightMQ.enable)
		additionalClasses.push(`videotext-${VideoTextHeightMQ.numberOfCols}`);
	return (
		<div className={`ws-content-row-video ${additionalClasses.join(' ')}`}>
			{/* eslint-disable jsx-a11y/media-has-caption */}
			<video
				width={videoWidth}
				height={videoHeight}
				{...additionalVideoProps}
			>
				<source src={videoSrc} />
			</video>
			{/* eslint-enable jsx-a11y/media-has-caption */}
		</div>
	);
};

export default Video;

export const VideoProps = {
	data: propTypes.shape({
		videoSrc: propTypes.string,
		videoThumbNail: propTypes.string,
		videoWidth: propTypes.string,
		videoHeight: propTypes.string,
		showControls: propTypes.bool,
		autoPlay: propTypes.bool,
		loop: propTypes.bool,
		muted: propTypes.bool,
		VideoTextHeightMQ: propTypes.shape({
			enabled: propTypes.bool,
			numberOfCols: propTypes.number
		})
	}).isRequired
};

Video.propTypes = VideoProps;
